import axios from "axios";
import {API_HOST} from "@/core/variables";

class AnalyticsRepository {

    async getBasicStatistics(startDate?: string, endDate?: string) {
        return axios.get(`${API_HOST}/v2/analytics/basic-statistics`, {
            params: {
                startDate,
                endDate
            }
        })
    }

    async getUsageStatistics() {
        return axios.get(`${API_HOST}/v2/analytics/usage-statistics`);
    }

    async refreshUsageStatistics() {
        return axios.get(`${API_HOST}/v2/analytics/usage-statistics/refresh`, {
            timeout: 300000
        });
    }
}
const analyticsRepository = new AnalyticsRepository();
export default analyticsRepository;
